import React from "react";
import {ReactComponent as Plus} from "apps/DRAW_PREDICTOR/assets/images/icons/plus.svg";
import styled from "styled-components";
import {media} from "assets/css/media";
import {LANGUAGE_PATH, useMediaQuery} from "modules";
import {useTranslation} from "react-i18next";

const Wrapper = styled.div`
	display: flex;
	align-items: center;
	height: 50px;
	width: 130px;
	justify-content: space-between;
	@media (max-width: ${media.mobile}) {
		height: auto;
		flex-direction: column;
		justify-content: center;
		width: 100%;
		margin-bottom: 5px;
	}
	p {
		font-weight: 600;
		font-family: "Qatar2022";
		font-style: normal;
		font-size: 16px;
		line-height: 160%;
		color: #000;
	}
`;
const PlusWrapp = styled.div`
	border-radius: 50%;
	width: 28px;
	height: 28px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #8a1538;
	cursor: pointer;
`;

interface IProps {
	predictionAllowedToChange: boolean;
}

const SquadNameEmptyBlock = styled.div`
	width: 100%;
	max-width: 99px;
	height: 15px;
	background: #a6a6a6;
	opacity: 0.2;
`;

export const AddPrediction: React.FC<IProps> = ({predictionAllowedToChange}) => {
	const isMobile = useMediaQuery(`(max-width: ${media.mobile})`);
	const {t} = useTranslation(LANGUAGE_PATH);
	const key = isMobile ? "mobile.draw.add" : "draw.group.add_team";

	if (!predictionAllowedToChange) {
		return <SquadNameEmptyBlock />;
	}
	return (
		<Wrapper>
			<p>{t(key)}</p>
			<PlusWrapp className="plus-icon">
				<Plus />
			</PlusWrapp>
		</Wrapper>
	);
};
